import { render, staticRenderFns } from "./pdfparametreler.vue?vue&type=template&id=774feec3&"
import script from "./pdfparametreler.vue?vue&type=script&lang=js&"
export * from "./pdfparametreler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports